import React from 'react'

import styled from 'styled-components'

import TextInput from 'components/TextInput'
import { scrubNumber } from 'helpers/inputCleaners'

export type Props = {
  isEditing: boolean
  value?: number | null
  onChangeCallback: (value: number | null) => void
}

const ConfigInput = ({ isEditing, value, onChangeCallback }: Props) => {
  return (
    <React.Fragment>
      {isEditing ? <S.Input type="number" min={0} value={value || ''} onChange={(event) => onChangeCallback(scrubNumber(event.target.value, true))} /> : (value || '--')}
    </React.Fragment>
  )
}

export default ConfigInput

const S = {
  Input: styled(TextInput)`
    margin-right: 10px;
    margin-bottom: -4px;
    margin-top: -5px;

    > input:first-of-type {
      font-weight: 700;
      font-size: 0.85rem;
      border-radius: 4px;
      line-height: 1;
      height: 26px;
      margin: 0;
      padding-top: 0;
      padding-bottom: 0;
    }
  `
}
